enum AddressType {
    Home = 'home',
    Work = 'work',
    Mailing = 'mailing',
}

export { AddressType };
